export default __webpack_public_path__ + "static/media/s3.61026bb2.svg";